var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-block-10 auto"},[_c('p',{staticClass:"current-menu gray66"},[_c('i',{staticClass:"fa fa-home grayae"}),_vm._v("\n    "+_vm._s(_vm.$route.path === '/data/brand/home' ? '隅西科技-虚拟员工230543-Haiyang-数字员工-客户部-数据分析' : _vm.currentRoute.name)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ac2330c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/default/SubMenu.vue
// module id = null
// module chunks = 